import React from 'react'
import { useSelector } from 'react-redux';
import { List, ListItem, ListItemText } from '@mui/material';
import IconStore from '@mui/icons-material/Store'
import IconAnalytics from '@mui/icons-material/Score'
import IconSettings from '@mui/icons-material/Settings'
import ListIcon from '@mui/icons-material/List';
import { makeStyles } from '@mui/styles';
import ListItemLink from './ListItemLink'
import classNames from 'classnames';
import IconProd from '@mui/icons-material/Domain'
import IconMaterials from '@mui/icons-material/ListAlt'
import PeopleIcon from '@mui/icons-material/People';
import { SLUGS } from 'src/enum/permissions.enum';
import { useFilterSidebar } from './hooks/useFilterSidebar';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  nestedOpen: {
    transition: theme.transitions.create('padding-left',
      {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    paddingLeft: theme.spacing(4),
  },
  nestedClose: {
    transition: theme.transitions.create('padding-left',
      {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    paddingLeft: theme.spacing(2),
  },
  selectedClass: {
    backgroundColor: '#909090'
  },
  selected: {
    backgroundColor: '#bababa'
  },
}));


const SIDEBAR_MENU_CONFIG = [
  { id: 'estimate', to: '/est-menu', icon: <ListIcon />, primary: 'Смета' },
  { id: 'document', to: '/documents', icon: <IconMaterials />, primary: 'Снабжение' },
  { id: 'production', to: '/prodmenu', icon: <IconProd />, primary: 'Производство' },
  { id: 'storage', to: '/storage', icon: <IconStore />, primary: 'Склад' },
  { id: 'analytics', to: '/analytics', icon: <IconAnalytics />, primary: 'Аналитика' },

  { id: 'settings', check: SLUGS.PROJECT.ROOT.UPDATE, to: `/settings`, icon: <IconSettings />, primary: 'Настройка' },
  { id: 'contractor', check: SLUGS.PROJECT.CONTRACTOR.LIST, to: `/contractor`, icon: <PeopleIcon />, primary: 'Подрядчики' },
]
export default function SelectedProject({ setSelected, selectedDriver, open }) {
  const classes = useStyles()
  const projectId = useSelector(state => state.header?.projectId || 0)
  const projectPath = `/projects/${projectId}`;
  const accessibleSidebarItems = useFilterSidebar(SIDEBAR_MENU_CONFIG);
  return (
    <List component="nav">
      <ListItem>
        <ListItemText inset primary={"Проект"} primaryTypographyProps={{ style: { fontWeight: 'bold' } }} />
      </ListItem>
      {accessibleSidebarItems.map(obj => <ListItemLink
        key={obj.id}
        disabled={projectId === 0}
        onClick={() => setSelected(obj.id)} {...obj}
        to={projectPath + obj.to}
        classes={
          classNames({
            [classes.nestedOpen]: open,
            [classes.nestedClose]: !open,
            [classes.selected]: selectedDriver === obj.id
          })
        }
      />)}
    </List>
  )
}